export default {
  //mutations
  SET_SCROLL_TOP: "SET_SCROLL_TOP",
  SET_TOKEN: "SET_TOKEN",
  SET_USER_INFO: "SET_USER_INFO",
  SET_LOGIN: "SET_LOGIN"
};
